import { RouteConfig } from 'vue-router';

import RouterView from '@/components/RouterView.vue';
import store from '@/store/store';
import { baseFilters } from '@/utils/baseFilters';
import { tryParseInt } from '@witkac/utils/tryParseInt';

export const containerRoutes: RouteConfig = {
  path: 'containers',
  meta: { toolbarTitle: 'Kontenery na punkty' },
  name: 'containers',
  redirect: { name: 'containerList' },
  component: RouterView,
  children: [
    {
      path: '',
      name: 'containerList',
      component: () => import(/* webpackChunkName: "ContainerList" */ '@/views/containers/List.vue'),
      beforeEnter: (to, from, next) => {
        store.commit('breadcrumbs/set', [{ text: 'Kontenery', to: { name: 'containerList' }, exact: true }]);
        return store
          .dispatch('pointContainers/list', baseFilters(to))
          .then(() => next())
          .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać listy kontenerów.' }));
      }
    },
    {
      path: 'history/:pointContainerId',
      name: 'containerHistory',
      component: () => import(/* webpackChunkName: "ContainerHistory" */ '@/views/containers/History.vue'),
      beforeEnter: (to, from, next) => {
        store.commit('breadcrumbs/set', [
          { text: 'Kontenery', to: { name: 'containerList' }, exact: true },
          { text: 'Historia', to: { name: 'containerHistory' }, exact: true, disabled: true }
        ]);
        return store
          .dispatch('pointHistory/list', {
            pointContainerId: tryParseInt(to.params.pointContainerId),
            ...baseFilters(to)
          })
          .then(() => next())
          .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać historii kontenera.' }));
      }
    }
  ]
};
